<template>
  <div style="font-size: 12px; line-height: 60px;">
    <div style="flex: 1; font-size: 21px; display: flex"> <!-- display: flex 打开弹性布局 -->
      <!-- line-height: unset 取消行高设置 -->
<!--      <span :class="collapseBtnClass" style="cursor: pointer; line-height: unset;" @click="collapse"></span>-->
      <!-- 面包屑导航 -->
      <!--   line-height: unset 取消行高设置 -->
      <el-breadcrumb separator-class="el-icon-arrow-right"
                     style="display: inline-block; margin-left: 10px; line-height: unset">
        <el-breadcrumb-item :to="'/'">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ currentPathName }}</el-breadcrumb-item>
      </el-breadcrumb>
      <!--   flex: 1 启用弹性布局，使该标签自动补全 div，text右对齐使-->
      <el-dropdown style="flex: 1; text-align: right; cursor: pointer">
        <span class="custom-font" style="padding-right: 8px;">{{ user.nickname }}</span><i class="el-icon-arrow-down"></i>
        <el-dropdown-menu slot="dropdown" style="width: 100px;">
          <el-dropdown-item>
            <div @click="$router.push('/showUserInfo')">
              <span style="text-decoration: none">个人信息</span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="loginOut">
              <span style="text-decoration: none">退出</span>
            </div>

          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

  </div>

</template>

<script>

import request from "@/util/request";
import {resetRouter} from "@/router";

export default {
  name: "Header",
  props: {
    collapseBtnClass: String,
    collapse: '',
    user: Object
  },
  data() {
    return {
      // // 浏览器获取
      // // 数据存在就将浏览器中的存储数据的字符串转为 JSON
      // user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
    }
  },

  mounted() {
    // 触发父级更新User的方法
    this.$emit("refreshUser")
    // 获取当前登录用户信息，供修改个人信息使用
    request.get("/user/getCurrentUser").then(res => {
      if (res.code === 200) {
        // 存入浏览器z
        localStorage.setItem("currentUser",JSON.stringify(res.data));
      }
    })
  },

  // 引用 store的 index.js，为了面包屑
  computed: {
    currentPathName() {
      return this.$store.state.currentPathName; // 监听的数据
    }
  },
  // 监听路由变化，为了面包屑
  watch: {
    currentPathName(newVal, oldVal) {
      console.log(newVal);
    }
  },
  methods: {
    // 退出登录
    loginOut() {
      this.$router.push("/login");
      localStorage.removeItem("user");
      localStorage.removeItem("currentUser");
      localStorage.removeItem("menus");
      // 重置路由
      resetRouter()
      this.$message.success("退出成功")
    }
  },

}
</script>

<style scoped>
.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 33px;
  font-size: 14px;
}
</style>
